import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';

import FormInput from '@components/form-input';

import './message-form.scss';
import CKEditorField from '@components/form-ckeditor/form-ckeditor';
import {ActionButton} from '@components/buttons/actionButton';
import {i18n} from '@src/i18n';

const requiredTitle = value => {
  if(value === undefined) {
    return undefined;
  }
  if(value === '' || !value.length) {
    return  i18n('message.form-missing-subject');
  }

  return undefined;
};

const requiredMessage = value => {
  if(value === undefined) {
    return undefined;
  }
  if(value === '' || !value.length) {
    return i18n('message.form-missing-body');
  }

  return undefined;
};

const MessageForm = ({handleSubmit, onCancel}) => (
  <form
    onSubmit={handleSubmit}
    className="message-form"
  >
    <div className="message-form__input-wrapper">
      <Field
        className="message-form__input"
        component={FormInput}
        label={i18n('message.subject')}
        name="title"
        validate={[requiredTitle]}
        type="text"
      />
    </div>
    <div className="message-form__input-wrapper">
      <Field
        autoComplete="name"
        className="message-form__input"
        component={CKEditorField}
        label={i18n('message.text')}
        name="emailBody"
        validate={[requiredMessage]}
        type="text"
      />
    </div>
    <div className="message-form__buttons-wrapper">
      <ActionButton
        variant="text"
        theme="black"
        onClick={onCancel}
        type="button"
      >
        {i18n('globals.cancel')}
      </ActionButton>

      <ActionButton
        variant="round"
        theme="black"
        type="submit"
      >
        {i18n('person.send')}
      </ActionButton>
    </div>
  </form>
);

MessageForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

MessageForm.defaultProps = {onCancel: () => {}};

export default reduxForm({form: 'message'})(MessageForm);
